import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const CheckmarkSmall = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M6.5 13.1592L10.3464 16.2501L17.5 7.75012'
        stroke='currentColor'
        strokeWidth='1.69096'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M6.5 13.1592L10.3464 16.2501L17.5 7.75012'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    )}
  </IconBase>
);
